module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Ethics & Malpractice Statement")]), _vm._v(" "), _c('ethics-and-malpractice-content')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72340032"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/EthicsAndMalpracticePage.vue
// module id = 1452
// module chunks = 1